import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "services/common"
import { TripDetailsResponseData } from "services/get-trip-details"

export const defaultUrlDev = `${process.env.REACT_APP_BASE_API_URL || ""}`

// -------- get booking data for calendar screen [ review & publish ]----------
export interface ListingDataType {
  isReviewPending: boolean
  imageLink: string
  airbnbImageUrl: string
  propertyName: string
  state: string
  city: string
  noOfBeds: number
  noOfBaths: number
  photosCount: number
  airbnbUrl: string
  airbnbLastSyncDt: number
  status: "LIVE" | "INACTIVE" | "PENDING" | "UNPUBLISHED"
  propertyId: string
  pmcId: string
  unitId: string
  _id: string
  pmsSystem: string
}

export interface GetBookingDataForCalendarScreenResponseData
  extends ResponseData {
  data: TripDetailsResponseData
}

export interface GetBookingDataForCalendarScreenResponse extends AxiosResponse {
  data: GetBookingDataForCalendarScreenResponseData
}

export interface GetBookingDataForCalendarScreenRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    bookingNumber: string
  }
}

export function getBookingDataForCalendarScreen(
  { params }: GetBookingDataForCalendarScreenRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    params,
    method: "get",
    url: `${defaultUrlDev}/booking/get-booking-data`,
  }) as Promise<GetBookingDataForCalendarScreenResponse>
}
